import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/practice";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/practice")(withAlternates(routeOptions, "/practice"));
